import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { SpotCard } from "@/components/SpotCard";
import { EventCard } from "@/components/EventCard";
import { useLanguage } from "@/i18n/LanguageContext";

export default function FavorisPage() {
  const { user, favorites } = useAuth();
  const { t } = useLanguage();

  if (user === false) {
    return (
      <main data-testid="favoris-page" className="mx-auto flex max-w-xl flex-col items-center px-4 py-24 text-center">
        <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-3xl bg-red-50">
          <Heart className="h-8 w-8 text-red-400" />
        </div>
        <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">{t("Tes favoris")}</h1>
        <p className="mt-3 text-slate-500">{t("Connecte-toi pour enregistrer tes coups de cœur et les retrouver ici.")}</p>
        <Link
          to="/connexion"
          data-testid="favoris-login-button"
          className="mt-8 rounded-full bg-[#2563EB] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#1D4ED8]"
        >
          {t("Se connecter")}
        </Link>
      </main>
    );
  }

  const entries = Object.entries(favorites);

  return (
    <main data-testid="favoris-page" className="mx-auto max-w-7xl px-4 py-10 sm:px-6">
      <h1 className="text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">{t("Tes favoris")}</h1>
      <p className="mt-2 text-sm text-slate-500">{t("Tous tes coups de cœur, au même endroit.")}</p>
      {entries.length === 0 ? (
        <p data-testid="favoris-empty" className="mt-10 rounded-3xl border border-slate-100 bg-white p-10 text-center text-sm text-slate-400">
          {t("Aucun favori pour l’instant. Touche le cœur sur un spot ou un événement pour l’ajouter ici.")}
        </p>
      ) : (
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {entries.map(([key, item]) =>
            key.startsWith("etablissement:") ? (
              <SpotCard key={key} spot={item} />
            ) : (
              <EventCard key={key} event={item} />
            )
          )}
        </div>
      )}
    </main>
  );
}
